"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debtRemoveMessage = debtRemoveMessage;
/**
 * What removing a debt does, in the words both clients' confirm shows
 * (BEN-141 FP-034).
 *
 * Both said the debt "stays in your history". It does not: removal sets the debt
 * INACTIVE (`DebtViewSet.perform_destroy`), and the only history list, Paid Off,
 * shows PAID_OFF debts. A user choosing between Remove and Paid Off was told the
 * two keep it equally; Paid Off keeps it visible, Remove makes it disappear. What
 * IS kept is the money: payments to the debt are transactions, which nothing
 * touches.
 */
function debtRemoveMessage(name) {
    return `"${name}" comes off your list and your payoff plan, and stops affecting the calculations. Its past payments stay in Transactions.`;
}
//# sourceMappingURL=debtRemoveCopy.js.map